import React, { useState } from 'react';
import { Button, Grid, makeStyles, Modal } from '@material-ui/core';
import Fetching from '../utils/Fetching';
import TextField from '../../Components/Fields/TextField'
import MoneyField from '../../Components/Fields/MoneyField';
import { Field, Form } from 'react-final-form';

const useStyles = makeStyles(theme => ({
  modal: {
    background: theme.palette.white,
    position: 'absolute',
    margin: 'auto',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    width: '230px',
    height: '280px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    outline: 0,
    borderRadius: 20
  },
  input: {
    display: 'flex',
    justifyContent: 'center',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(1)
  },
  button: {
    display: 'flex',
    justifyContent: 'space-around',
    paddingTop: theme.spacing(3)
  },
  field: {
    width: "100%"
  },
}));


export default (props) => {
  
  const classes = useStyles();

  const { modalOpen, setModalOpen, saveAction, initialValues } = props;

  const [fetching, setFetching] = useState(false);

  const handleSave = (values) => {
    setFetching(true);
    saveAction(values);
    setFetching(false);
    setModalOpen(false);
  }

  const validateFields = values => ({
    nome: !values.nome ? "Campo obrigatório" : undefined,
    valor: !values.valor ? "Campo Obrigatório" : undefined,
    duracao: !values.duracao ? "Campo Obrigatório" : undefined
  });

  return <Modal
    open={modalOpen}
    onClose={() => setModalOpen(false)}
  >
    <div className={classes.modal}>
      <Fetching isFetching={fetching}>
        <Form
          onSubmit={handleSave}
          initialValues={initialValues || {}}
          validate={validateFields}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>   
              <Grid container>
                <Grid item xs={12} className={classes.input}>
                  <Field
                    className={classes.field}
                    name="nome"
                    label="Nome"
                    placeholder="Nome da Quadra"
                    component={TextField}
                  />
                </Grid>
                <Grid item xs={12} className={classes.input}>
                  <Field
                    className={classes.field}
                    name="valor"
                    label="Valor da Reserva"
                    component={MoneyField}
                  />
                </Grid>
                <Grid item xs={12} className={classes.input}>
                  <Field
                    className={classes.field}
                    name="duracao"
                    label="Duração reserva (minutos)"
                    defaultValue="60"
                    component={TextField}
                  />
                </Grid>
                <Grid item xs={12} className={classes.button}>
                  <Button 
                    type="submit"
                    color="primary"
                    variant="contained"
                    size="small"
                  >
                    {"SALVAR"}
                  </Button>
                  <Button
                    color="secondary"
                    size="small"
                    onClick={() => setModalOpen(false)}
                  >
                    {"CANCELAR"}
                  </Button>
                </Grid>
              </Grid>
            </form>)}
          />
      </Fetching>
    </div>
  </Modal>
}